import api from "../index";

const createPreInvestment = (data) => {
  return api.post(`/admin/pre-investment`,data);
};


export { createPreInvestment };
